import { Underconstruction } from "../WorkerComp/Utils"
export default function Resume(){
    return(
        <>
        <Underconstruction name="Resume"/>
        </>
       )
}